import { Box, Button, Text } from "@saleor/macaw-ui-next";
import React from "react";

interface EmptyStateProps {
  icon: React.ComponentType<{ size?: number | string }>;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  message,
  actionLabel,
  onAction,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    padding={8}
    borderWidth={1}
    borderStyle="solid"
    borderColor="default1"
    borderRadius={4}
    gap={3}
  >
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      __width="56px"
      __height="56px"
      borderRadius={4}
      __backgroundColor="rgba(148, 163, 184, 0.08)"
    >
      <Icon size={28} />
    </Box>
    <Text size={3} color="default2" __textAlign="center">
      {message}
    </Text>
    {actionLabel && onAction && (
      <Button variant="secondary" size="small" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </Box>
);
